(function () {
  'use strict';

  const STORAGE_KEY = 'artjag:lastShoppingUrl';

  function isShoppingPage(path) {
    if (path.includes('/products/')) return true;
    if (path.includes('/collections/')) return true;
    // Metaobject-driven collection pages under /pages/ have 2+ path segments
    // after /pages/ (e.g. /pages/bcu/t-1014-091). Single-segment info pages
    // like /pages/about are intentionally excluded.
    if (/^\/pages\/[^\/]+\/[^\/]+/.test(path)) return true;
    return false;
  }

  function trackCurrentPage() {
    if (isShoppingPage(window.location.pathname)) {
      try {
        sessionStorage.setItem(STORAGE_KEY, window.location.pathname + window.location.search);
      } catch (e) {
        // sessionStorage unavailable (private browsing, quota, etc.) — silently skip
      }
    }
  }

  function resolveTarget() {
    try {
      return sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function handleClick(event) {
    const target = resolveTarget();
    if (target) {
      event.preventDefault();
      window.location.href = target;
    }
    // No target → let the anchor's href (homepage) take over
  }

  function init() {
    trackCurrentPage();

    // Re-track just before the page unloads. This captures any URL changes
    // made via history.replaceState (e.g. Shopify's variant selector) so the
    // stored URL reflects the final page state at navigation time.
    window.addEventListener('pagehide', trackCurrentPage);

    const buttons = document.querySelectorAll('.js-continue-shopping');
    buttons.forEach(function (button) {
      button.addEventListener('click', handleClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
